import { useContext } from "react";
import { PixKeyContext } from "../contexts/PixKeyContext";

export function usePixKey() {
  const context = useContext(PixKeyContext);

  return context;
}
